import React, { useState } from 'react'
import styles from './skils.module.scss'
import htmlIcon from './img/icons8-html.svg'
import cssIcon from './img/icons8-css.svg'
import javaScriptIcon from './img/icons8-javascript.svg'
import reactIcon from './img/icons8-nativo-de-reagir.svg'
import typescriptIcon from './img/icons8-typescript.svg'
import nodeIcon from './img/icons8-node-js.svg'
import PhpIcon from './img/icons8-php.svg'
import TailwindCSSIcon from './img/icons8-tailwindcss.svg'
import NextJsIcon from './img/icons8-nextjs.svg'
import pythonIcon from './img/icons8-python.svg'
import classNames from 'classnames'
import SectionBorder from 'components/Section-Border'

export default function Skills() {
  const [technicalSkills, setTechnicalSkills] = useState(false);
  const [professionalSkills, setProfessionalSkills] = useState(false);

  const circles = [
    { name: 'Leadership', dots: 90, marked: 77, id: '1', professional: false },
    { name: 'Communication', dots: 90, marked: 82, id: '2', professional: false },
    { name: 'Creativity', dots: 90, marked: 80, id: '3', professional: false },
    { name: 'Innovation', dots: 90, marked: 88, id: '4', professional: false },
    { name: 'Problem solving', dots: 90, marked: 78, id: '6', professional: true },
    { name: 'Web Frameworks', dots: 90, marked: 75, id: '7', professional: true },
    { name: 'UX and UI Design', dots: 90, marked: 70, id: '8', professional: true },
    { name: 'Responsive Design', dots: 90, marked: 68, id: '9', professional: true },

    
  ];

  const circleCenter = [
    { name: 'Team Work', dots: 90, marked: 90, id: '5', professional: false },
    { name: 'Logic', dots: 90, marked: 80, id: '10', professional: true },
  ];



  const filteredCircles = circles.filter(
    (circle) => circle.professional === professionalSkills
  );

  const filteredCircleCenter = circleCenter.filter(
    (circle) => circle.professional === professionalSkills
  );

  
  const toggleTechnicalSkillsNext = () => {
    setTechnicalSkills(true);
  };

  const toggleTechnicalSkillsPrevious = () => {
    setTechnicalSkills(false);
  };

  const toggleProfessionalSkillsNext = () => {
    setProfessionalSkills(true);
  };

  const toggleProfessionalSkillsPrevius = () => {
    setProfessionalSkills(false);
  };
  return (
      <section className={styles.container} id="skils">
          <div className={classNames(styles.main_text, 'scroll_top')}>
              <span>Technical and Professional</span>
              <h2>My Skills</h2>
          </div>

          <div className={styles.skills_main}>
              <div className={classNames(styles.skill_left, 'scroll_bottom')}>
                  <h3 style={{marginBottom: '1.5em'}}>
                    <button className={styles.arrow1} style={{opacity: technicalSkills ? '1' : '0.5'}} onClick={() => toggleTechnicalSkillsPrevious()}></button>Technical Skills
                    <button className={styles.arrow2} style={{opacity: !technicalSkills ? '1' : '0.5',}} onClick={() => toggleTechnicalSkillsNext()}></button>
                  </h3>
                  
              {!technicalSkills && (
                <>
                  <div className={styles.skill_bar}>
                      <div className={styles.info}>
                          <p> <img src={htmlIcon} alt="" style={{marginRight: '0.4em'}} className={styles.technology_icons} /> HTML</p>
                          <p>90%</p>
                      </div>
                      <div className={styles.bar}>
                          <span className={styles.html}></span>
                      </div>
                  </div>

                  <div className={styles.skill_bar}>
                      <div className={styles.info}>
                          <p> <img src={cssIcon} alt="" style={{marginRight: '0.4em'}} className={styles.technology_icons} /> CSS</p>
                          <p>80%</p>
                      </div>
                      <div className={styles.bar}>
                          <span className={styles.css} ></span>
                      </div>
                  </div>

                  <div className={styles.skill_bar}>
                      <div className={styles.info}>
                          <p> <img src={javaScriptIcon} alt="" style={{marginRight: '0.4em'}} className={styles.technology_icons}/> JavaScript</p>
                          <p>82%</p>
                      </div>
                      <div className={styles.bar}>
                          <span className={styles.javaScript}></span>
                      </div>
                  </div>

                  <div className={styles.skill_bar}>
                      <div className={styles.info}>
                          <p> <img src={reactIcon} alt="" style={{marginRight: '0.4em'}} className={styles.technology_icons}/> React</p>
                          <p>88%</p>
                      </div>
                      <div className={styles.bar}>
                          <span className={styles.react}></span>
                      </div>
                  </div>

                  <div className={styles.skill_bar}>
                      <div className={styles.info}>
                          <p>
                            <img src={typescriptIcon} alt="" style={{marginRight: '0.4em'}} className={styles.technology_icons}/>
                            TypeScript</p>
                            <p>77%</p>
                      </div>
                      <div className={styles.bar}>
                          <span className={styles.typeScript}></span>
                      </div>
                  </div>
              </>
            )}
              {technicalSkills && (  
                <>
                  <div className={styles.skill_bar}>
                      <div className={styles.info}>
                          <p>
                            <img src={NextJsIcon} alt="" style={{marginRight: '0.4em'}} className={styles.technology_icons}/>
                              Next Js</p>
                            <p>62%</p>
                      </div>
                      <div className={styles.bar}>
                          <span className={styles.NextJs}></span>
                      </div>
                  </div>

                  <div className={styles.skill_bar}>
                      <div className={styles.info}>
                          <p>
                          <img src={TailwindCSSIcon} alt="" style={{marginRight: '0.4em'}} className={styles.technology_icons} />
                            Tailwind Css</p>
                            <p>80%</p>
                      </div>
                      <div className={styles.bar}>
                          <span className={styles.TailwindCss}></span>
                      </div>
                  </div>

                  <div className={styles.skill_bar}>
                      <div className={styles.info}>
                          <p>
                            <img src={pythonIcon} alt="" style={{marginRight: '0.4em'}} className={styles.technology_icons}/>
                              Python</p>
                            <p>60%</p>
                      </div>
                      <div className={styles.bar}>
                          <span className={styles.python}></span>
                      </div>
                  </div>

                  <div className={styles.skill_bar}>
                      <div className={styles.info}>
                          <p>
                            <img src={PhpIcon} alt="" style={{marginRight: '0.4em'}} className={styles.technology_icons} />
                            PHP</p>
                            <p>68%</p>
                      </div>
                      <div className={styles.bar}>
                          <span className={styles.PHP}></span>
                      </div>
                  </div>

                  <div className={styles.skill_bar}>
                      <div className={styles.info}>
                          <p>
                            <img src={nodeIcon} alt="" style={{marginRight: '0.4em'}} className={styles.technology_icons} />
                            Node Js</p>
                            <p>77%</p>
                      </div>
                      <div className={styles.bar}>
                          <span className={styles.nodeJs}></span>
                      </div>
                  </div>
                </>
              )}
          </div>
              
          <div className={classNames(styles.skill_right, 'scroll_bottom')}>
          <h3 style={{marginBottom: '2em'}}>
            <button
              className={styles.arrow1}
              style={{ opacity: professionalSkills ? '1' : '0.5' }}
              onClick={toggleProfessionalSkillsPrevius}
            ></button>
            Professional Skills
            <button
              className={styles.arrow2}
              style={{ opacity: !professionalSkills ? '1' : '0.5' }}
              onClick={toggleProfessionalSkillsNext}
            ></button>
          </h3>
          <div
            className={styles.professional}
          >
            {filteredCircles.map((circle, index) => {
              const { name, dots, marked } = circle;
              const rotate = 360 / dots;

              const points = Array.from({ length: dots }, (_, i) => (
                <div
                  key={i}
                  className={`${styles.points} ${
                    i <= Math.floor((marked / 100) * dots) ? styles.marked : ''
                  }`}
                  style={{ '--i': i, '--rot': `${rotate}deg`, margin: '10px' }}
                ></div>
              ));

              return (
                <div key={circle.id} className={styles.box}>
                  <div
                    className={`${styles.circle} circle`}
                    data-dots={dots}
                    data-percent={marked}
                  >
                    {points}
                  </div>
                  <div className={styles.text}>
                    <big>{`${marked}%`}</big>
                    <small>{name}</small>
                  </div>
                </div>
              );
            })}

            {filteredCircleCenter.map((circle, index) => {
              const { name, dots, marked } = circle;
              const rotate = 360 / dots;

              const points = Array.from({ length: dots }, (_, i) => (
                <div
                  key={i}
                  className={`${styles.points} ${
                    i <= Math.floor((marked / 100) * dots) ? styles.marked : ''
                  }`}
                  style={{ '--i': i, '--rot': `${rotate}deg`, margin: '10px' }}
                ></div>
              ));

              return (
                <div key={circle.id} id={styles.circleCenterBox}className={styles.box}>
                  <div
                    className={`${styles.circle} circle`}
                    id={styles.circleCenter}
                    data-dots={dots}
                    data-percent={marked}
                  >
                    {points}
                  </div>
                  <div className={styles.text} id={styles.circleCenterText}>
                    <big>{`${marked}%`}</big>
                    <small>{name}</small>
                  </div>
                </div>
              );
            })}

          </div>
        </div>
      </div>
      <SectionBorder />
    </section>
  );
}